const loadExportsJS = function (url) {
  return new Promise(resolve => {
    let domScript = document.createElement('script');
    domScript.src = url;
    domScript.onload = domScript.onreadystatechange = function () {
      if (!this.readyState || 'loaded' === this.readyState || 'complete' === this.readyState) {
        this.onload = this.onreadystatechange = null;
        resolve(true);
      }
    }
    document.getElementsByTagName('head')[0].appendChild(domScript);
  })
}
export default loadExportsJS
